import * as actions from './actions'

export default {
  actions,
  namespaced: true,
}
